module.exports = __webpack_public_path__ + "img/e0f9e79.jpg";